import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DEFAULT_PROFILE_COLOR, EnvironmentProfileAppearance} from './environment-profile.service';

interface ProfileClient {
  uuid?: string;
  environmentProfile?: EnvironmentProfileAppearance | null;
}

@Component({
  selector: 'app-environment-profile-indicator',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="activeProfile as active" class="profile-context" role="status"
         [style.--profile-color]="active.color || defaultColor">
      <span class="color-dot" aria-hidden="true"></span>
      <span>Environment: <strong>{{ active.name }}</strong></span>
    </div>
  `,
  styles: [`
    :host { display: block; flex-shrink: 0; }
    .profile-context {
      display: flex; align-items: center; gap: 8px; margin: 8px; padding: 8px 12px;
      border: 1px solid color-mix(in srgb, var(--profile-color) 35%, transparent);
      border-left: 3px solid var(--profile-color); border-radius: 6px;
      background: color-mix(in srgb, var(--profile-color) 8%, #fff);
      color: #334155; font-size: 13px; line-height: 20px; overflow-wrap: anywhere;
    }
    .color-dot { width: 8px; height: 8px; border-radius: 50%; background: var(--profile-color); flex-shrink: 0; }
  `],
})
export class EnvironmentProfileIndicatorComponent {
  @Input() clients: readonly ProfileClient[] = [];
  @Input() clientUuids: readonly string[] | null = null;
  @Input() profile?: EnvironmentProfileAppearance | null;
  readonly defaultColor = DEFAULT_PROFILE_COLOR;

  get activeProfile(): EnvironmentProfileAppearance | null {
    if (this.profile !== undefined) return this.profile;
    const selected = this.clientUuids !== null
      ? this.clients.filter(client => this.clientUuids!.includes(client.uuid!)) : this.clients;
    if (this.clientUuids !== null && selected.length !== new Set(this.clientUuids).size) return null;
    const first = selected[0]?.environmentProfile;
    return first && selected.every(client => client.environmentProfile?.uuid === first.uuid) ? first : null;
  }
}
